import { AgentsVoicePage } from 'app/components/agents-hub/AgentPages'

export const handle = {
  title: `Agents · Voice`,
  breadcrumb: `Voice`,
}

export default function AgentsVoiceRoute() {
  return <AgentsVoicePage />
}
